import gql from 'graphql-tag';

export const getChargeCodeQuery = gql(/* GraphQL */ `
  query getChargeCode($getChargeCodeRequest: GetChargeCodeRequest!) {
    chargeCode(getChargeCodeRequest: $getChargeCodeRequest) {
      id
      chargeCode
      glCode
      description
      groupId
      groupType
      chargeCodeSource
    }
  }
`);
